<div class="login_container">


    <form name="login_form" #login_form="ngForm" (ngSubmit)="login()">
        <div class="row">
            <div class="col-12 col-sm-2 col-md-3 col-lg-4"></div>
            <div class="col-12 col-sm-8 col-md-6 col-lg-4">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <img class="img" src="assets/images/dryclean_New_AllPages_logo_v4.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-3">
                        <div class="form-group">
                            <input type="text" id="Username" name="Username" placeholder="Enter User Name" #Username="ngModel" [ngClass]="{ 'is-invalid': login_form.submitted && Username.invalid }" [(ngModel)]="loginModel.Username" class="form-control" required />
                            <div *ngIf="login_form.submitted && Username.invalid" class="invalid-feedback">
                                <h6>User name is required.</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2">
                        <div class="form-group">
                            <input type="password" id="Password" name="Password" placeholder="Enter Password" #Password="ngModel" [ngClass]="{ 'is-invalid': login_form.submitted && Password.invalid }" [(ngModel)]="loginModel.Password" class="form-control" required />
                            <div *ngIf="login_form.submitted && Password.invalid" class="invalid-feedback">
                                <div *ngIf="Password.errors.required">
                                    <h6>Password is required</h6>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary">
                                                    Login
                                            </button>
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <br>








    </form>
</div>